import React, { FC } from "react";
import "./Sitemap.css";
import { Container, Divider, Grid, Typography } from "@material-ui/core";
import { useHistory } from "react-router";

const SocMedIcon = ({ base = "/images/home-page/", src, alt }) => {
  return (
    <img
      style={{ height: 45, width: 45, cursor: "pointer" }}
      src={`${base}${src}`}
      alt={alt}
    />
  );
};

const SitemapPrototype = ({ footer_links = [] }): FC => {
  const navigate = useHistory();
  return (
    <div className="root-footer horizontal-center vertical-center">
      <Container>
        <Grid container>
          <Grid item md={5} style={{ justifyContent: "right" }}>
            <div style={{ textAlign: "left", justifyItems: "right" }}>
              <Typography className="text-font">
                A subsidiary of the Filinvest Group.
              </Typography>
              <br />{" "}
              <Typography className="text-font">
                Deposits are insured by PDIC up to P500,000 per depositor
              </Typography>
              <br />
              <div
                className=" flex-direction-row "
                style={{ alignItems: "center" }}
              >
                <Typography className="text-font">
                  A proud member of &nbsp;
                </Typography>{" "}
                <img
                  alt="Bancnet logo"
                  src="/images/BancnetLogo.png"
                  style={{ height: 18, width: 80, padding: 0 }}
                />
                <img
                  alt="NPC Seal Of Registration"
                  src="/images/logos/npc-seal-of-registration-large-2025.png"
                  style={{ width: 55, height: 70 }}
                />
              </div>
              <br />
              <Typography className="text-font" gutterBottom>
                For inquiries and feedback:
                <br /> +632 8888-1700 (24-Hour Customer Service)
                <br />
                service@eastwestbanker.com. (email)
                <br />
                <br />
                EastWest is regulated by the Bangko Sentral ng Pilipinas.
                <br /> https://www.bsp.gov.ph
              </Typography>
            </div>
          </Grid>{" "}
          <Grid
            item
            xs={2}
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Divider
              orientation="vertical"
              style={{
                height: "100%",
                width: "1px",
                color: "white",
                backgroundColor: "white",
              }}
            />
          </Grid>
          <Grid item md={5} style={{ justifyContent: "right" }}>
            <div className="flex-direction-row">
              <SocMedIcon alt="facebook" src="fb-icon.png" />
              <SocMedIcon alt="twitter" src="twitter-icon.png" />
              <SocMedIcon alt="linkedin" src="linkedin-icon.png" />
              {/* <SocMedIcon alt="instagram" src="instagram-icon.png" />
              <SocMedIcon alt="youtube" src="youtube-icon.png" /> */}
            </div>
            <br />
            <Typography className="text-font"> ABOUT EASTWEST BANK</Typography>
            <br />
            <Grid container spacing={1}>
              {footer_links?.map(({ title, relative }) => {
                return (
                  <Grid item md={6}>
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        navigate.push(relative);
                      }}
                    >
                      <Typography className="text-font">{title}</Typography>
                    </div>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default SitemapPrototype;
